import {Pipe, PipeTransform} from '@angular/core';
import {TupleIdName} from '../models/tuple.model';
import {I18nService} from '../../shared/i18n';
import {ActionTypeCodebook} from '../codebook/action-type-codebook';
import {CodebookModel} from '../models/codebook.model';
import {BindingTypeCodebook} from '../codebook/binding-type-codebook';

@Pipe({
    name: 'bindingType'
})
export class BindingTypePipe implements PipeTransform {
    private allTypes:CodebookModel[] = BindingTypeCodebook.allTypes;
    constructor() {
    }


    transform(value: any, args?: any): any {

        let  type = this.allTypes.filter(type => type.id === value)[0];
        if(type == null) {
            type = {id:-1,name:'n/a'}
        }
        return type.name;
    }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/pipes/bindingType.pipe.ts